<!--简历编辑-语言能力-ciel-->
<template>
	<div class="language-ability">

		<h3 class="c-title">语言能力
			<a href="javascript:;" class="btn-add" :class="{'disabled':isEditting||!editable}" v-show="status!=0" @click="callOutAddNewItemModal">
				<i class="icon">
					<img src="../../assets/img/common/icon-add-off.png" v-if="isEditting||!editable"/>
					<img src="../../assets/img/common/icon-add.png" v-else="!isEditting&&editable"/>
				</i>
				<span>&nbsp;添加</span>
			</a>
		</h3>

		<!--原始无污染状态-->
		<div class="no-data" v-if="status==0">
			<resume-undone-template blockText="语言能力" :showTitle="false" :editable="editable" @editBtnClick="callOutAddNewItemModal" />
		</div>

		<!--新增项目的编辑-->
		<div class="editting mb30" v-if="showAddBox">
			<div class="row-24">
				<div class="row-12">
					<label class="label">语言种类</label>
					<el-select v-model="language" placeholder="请选择">
						<el-option v-for="(item,index) in languageOptions" :key="item.id" :label="item.languageName" :value="item.id">
						</el-option>
					</el-select>
				</div>

				<div class="row-12">
					<label class="label">熟练程度</label>
					<el-select v-model="level" placeholder="请选择">
						<el-option v-for="(item,index) in levelOptions" :key="item.id" :label="item.proficiency" :value="item.id">
						</el-option>
					</el-select>
				</div>
			</div>

			<div class="row-24-block no-mb">
				<a href="javascript:;" class="btn-operation btn-save" @click="resumeLanguageAbilityAddSave">保存</a>
				<!--cacelEdit-->
				<a href="javascript:;" class="btn-operation btn-cancel" @click="addCancel">取消</a>
			</div>
		</div>

		<!--展示状态-->
		<div class="language-complete" v-if="status==1">
			<div class="language-item" v-for="(item,index) in itemList" :key="item.id">
				<h3 class="item-caption" v-if="item.show">
						<span class="job-title">{{item.languageInfo.languageName}}：{{item.proficiencyInfo.proficiency}}</span>
						<div class="operation-box">
							<a href="javascript:;" class="operation operation-edit" :class="{'disabled':isEditting||!editable}" @click="editCurrentItem(index,item)">
								<i class="icon icon-pencil">
									<img src="../../assets/img/common/icon-pencil.png" v-if="!isEditting&&editable"/>
									<img src="../../assets/img/common/icon-pencil-off.png" v-else="isEditting||!editable"/>
								</i>
								<span>编辑</span>
							</a>
							<a href="javascript:;" class="operation operation-delete" :class="{'disabled':isEditting||!editable}" @click="deleteResumeLanguageAbility(item.id)">
								<i class="icon icon-pencil">
									<img src="../../assets/img/common/icon-trash-on.png" v-if="!isEditting&&editable"/>
									<img src="../../assets/img/common/icon-trash-off.png" v-else="isEditting||!editable"/>
								</i>
								<span>删除</span>
							</a>
						</div>
					</h3>

				<!--原有项目的编辑-->
				<div class="editting" v-if="!item.show" style="background-color:#f9f9f9;margin:20px 0;">
					<div class="row-24">
						<div class="row-12">
							<label class="label">语言种类</label>
							<el-select v-model="language" placeholder="请选择">
								<el-option v-for="(item,index) in languageOptions" :key="item.id" :label="item.languageName" :value="item.id">
								</el-option>
							</el-select>
						</div>

						<div class="row-12">
							<label class="label">熟练程度</label>
							<el-select v-model="level" placeholder="请选择">
								<el-option v-for="(item,index) in levelOptions" :key="item.id" :label="item.proficiency" :value="item.id">
								</el-option>
							</el-select>
						</div>
					</div>

					<div class="row-24-block no-mb">
						<a href="javascript:;" class="btn-operation btn-save" @click="editSave(item)">保存</a>
						<!--cacelEdit-->
						<a href="javascript:;" class="btn-operation btn-cancel" @click="editCancel(index)">取消</a>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import ResumeUndoneTemplate from '@/components/EditResume/ResumeUndoneTemplate.vue'
	import { httpResumeLanguageOptionsGet, httpResumeLanguageAbilityGet, httpResumeLanguageAbilityAdd, httpResumeLanguageAbilityEdit, httpResumeLanguageAbilityDelete } from '@/api/resume'

	export default {
		name: 'ResumeLanguageAbility',
		components: {
			ResumeUndoneTemplate
		},
		props: {
			resumeId: {
				required: true
			},
			editable: {
				type: Boolean,
				required: true
			}
		},
		data() {
			return {
				status: 0, //0-初始状态，1-污染状态
				showAddBox: false, //指示是否纯粹新增选项
				isEditting: false, //指示是否当前是否正在编辑
				languageOptions: [],
				language: 1,
				levelOptions: [],
				level: 1,
				itemList: []
			}
		},
		mounted() {
			setTimeout(() => this.getResumeLanguageAbility(), 30);
		},
		methods: {

			//打开新增语言能力功能窗
			callOutAddNewItemModal() {
				if(this.isEditting || !this.editable) return;
				this.shouldIGetLanguageOptions();
				this.isEditting = true;
				this.showAddBox = true;
				this.status = 1;
				this.$emit('set-edit-status', 1);
			},

			//保存增加新的语言选项操作
			resumeLanguageAbilityAddSave() {
				let oData = {
					resumeId: this.resumeId,
					languageId: this.language,
					proficiencyId: this.level,
				};

				let canIsubmit = true;
				//如果是已有选项的话，提示不让新增
				this.itemList.forEach(item => {
					if(item.languageId == this.language) {
						canIsubmit = false;
					}
				})

				if(!canIsubmit) {
					this.$message({
						type: 'warning',
						message: '您的语言能力里已经有此选项了，请勿重复添加',
						duration: 1200
					})
					return;
				}

				httpResumeLanguageAbilityAdd(oData).then(r => {
					if(r.success) {
						this.$message({
							type: 'success',
							message: '新增成功',
							duration: 1200,
						})
						this.getResumeLanguageAbility();
						this.status = 1;
						this.showAddBox = false;
						this.isEditting = false;
						this.$emit('set-edit-status', 2);
					} else {
						console.log(r);
						this.$message.error('保存失败，请稍后再试。');
					}

				}).catch(err => {
					console.log(err);
					this.$message.error('保存失败，请稍后再试。');
				})
			},

			//取消新增语言选项
			addCancel() {
				[this.showAddBox, this.isEditting] = [false, false];
				if(!this.itemList.length) {
					this.status = 0;
				}
				this.$emit('set-edit-status', 2);
			},

			//点击编辑现有选项按钮
			editCurrentItem(index, item) {
				if(this.isEditting || !this.editable) return;
				this.shouldIGetLanguageOptions();
				this.itemList[index].show = false;
				this.isEditting = true;
				this.language = Number(item.languageId);
				this.level = Number(item.proficiencyId);
				this.$emit('set-edit-status', 1);
			},

			//保存现有选项 的编辑操作
			editSave(item) {
				//将当前项目的值赋给
				let oData = {
					resumeId: this.resumeId,
					id: item.id,
					languageId: this.language,
					proficiencyId: this.level
				}

				//判断是否真的发生修改-提示成功但不进行交互
				if(item.languageId == this.language && item.proficiencyId == this.level) {
					this.$message({
						type: 'success',
						message: '保存成功',
						duration: 800
					});
					item.show=true;
					this.status = 1;
					this.showAddBox = false;
					this.isEditting = false;
					this.$emit('set-edit-status', 2);
					return;
				}

				httpResumeLanguageAbilityEdit(oData).then(r => {
					//console.log(r);
					if(r.success) {
						this.$message({
							type: 'success',
							message: '修改成功',
							duration: 1200,
						})
						this.getResumeLanguageAbility();
						this.status = 1;
						this.showAddBox = false;
						this.isEditting = false;
						this.$emit('set-edit-status', 2);
					} else {
						this.$message.error('保存编辑失败，' + r.message);
					}
				}).catch(err => {
					console.log(err);
					this.$message.error('保存编辑失败，请您稍后再试！');
				})
			},

			//取消对现有选项的编辑，不改变任何数据
			editCancel(index) {
				this.isEditting = false;
				this.itemList[index].show = true;
				this.$emit('set-edit-status', 2);
			},

			//删除一项语言能力
			deleteResumeLanguageAbility(id) {
				if(this.isEditting || !this.editable) return;
				let oData = {
					ids: [id]
				}
				httpResumeLanguageAbilityDelete(oData).then(r => {
					//console.log(r);
					if(r.success) {
						this.$message({
							type: 'success',
							message: '删除成功',
							duration: 500
						});
						this.getResumeLanguageAbility();
						this.showAddBox = false;
						this.isEditting = false;
					} else {
						this.$message.error("删除失败，请稍后再试");
					}
				}).catch(err => {
					this.$message.error("删除失败，请稍后再试");
				});
			},

			//获取已有语言信息
			getResumeLanguageAbility() {
				if(!this.resumeId) return;
				let prama = this.resumeId;
				httpResumeLanguageAbilityGet(prama).then(r => {
					//console.log(r);
					if(r.success) {
						this.itemList = r.data;
						this.itemList.length ? this.status = 1 : this.status = 0;
						this.itemList.forEach(item => {
							this.$set(item, 'show', true);
						});
					}
				}).catch(error => {
					console.log(error);
					this.$notify({
						type: 'warning',
						title: '提示',
						message: '获取简历语言能力失败',
					});
				});
			},

			//判断是否应该获取一次语言能力选项
			shouldIGetLanguageOptions() {
				if(!this.languageOptions.length || !this.levelOptions.length) {
					this.getLanguageOptions();
				}
			},

			//获取语言选项
			getLanguageOptions() {
				httpResumeLanguageOptionsGet().then(r => {
					//console.log(r);
					if(r.success) {
						this.languageOptions = r.data.languages;
						this.levelOptions = r.data.languageProficiencys;
					} else {
						//this.$message.error("获取语言能力选项失败");
					}
				}).catch(err => {
					console.log(err);
					this.$message.error("获取语言能力选项失败");
				})
			}
		},
	}
</script>

<style scoped lang="less">
	@import url("../../assets/css/editResume.less");
	.language-ability {
		margin-bottom: 30px;
	}
	
	.language-item {
		position: relative;
		margin: 10px 0;
		.item-caption {
			span {
				font-size: 14px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/EditResume/ResumeLanguageAbility.vue